# This gets automatically populated bij gulp

exports.date = 1663536901
exports.branch = "master"
exports.hash = "477b95a8-dirty"
exports.build = 3295
exports.version = "#{exports.branch}/#{exports.hash}"



// WEBPACK FOOTER //
// ./build/Version.coffee